function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Communication / Chat_Conversation_Circle"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M12.4509 21.3213C16.6594 21.0875 20 17.601 20 13.334C20 8.91571 16.4183 5.33398 12 5.33398C7.58172 5.33398 4 8.91571 4 13.334C4 14.9083 4.45458 16.3762 5.23985 17.6139L4.67448 19.31L4.67358 19.3125C4.45703 19.9622 4.34871 20.2871 4.42585 20.5034C4.49306 20.6919 4.64225 20.8405 4.83073 20.9077C5.0463 20.9846 5.36899 20.877 6.01425 20.6619L6.02344 20.6591L7.72005 20.0937C8.95774 20.879 10.4258 21.3337 12.0001 21.3337C12.1514 21.3337 12.3016 21.3295 12.4509 21.3213ZM12.4509 21.3213C12.451 21.3216 12.4507 21.3209 12.4509 21.3213ZM12.4509 21.3213C13.5454 24.4352 16.5121 26.6675 20.0002 26.6675C21.5745 26.6675 23.0422 26.2124 24.2798 25.4271L25.976 25.9925L25.9794 25.9931C26.6289 26.2096 26.9544 26.3181 27.1707 26.241C27.3592 26.1738 27.5065 26.0252 27.5737 25.8367C27.6509 25.6201 27.5429 25.2948 27.3258 24.6434L26.7604 22.9473L26.9498 22.6335C27.6184 21.4646 27.9993 20.1104 27.9993 18.6673C27.9993 14.2491 24.4183 10.6673 20 10.6673L19.7005 10.6728L19.5495 10.6802",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.1f208f0a.svg";
export { ForwardRef as ReactComponent };